module.exports = __webpack_public_path__ + "img/inter-v11-latin-300.e2631ce.svg";